export function trimWithEllipses(text, length) {
  if (!text) return text;
  if (text.length < length + 3) return text;
  return `${text.substring(0, length)}...`;
}
